var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function Svg1183(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 1250 1250",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlSpace: "preserve",
    xmlnsSerif: "http://www.serif.com/",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 1.5
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M271.027,865.772l673.964,0.24c0,0 235.426,-25.046 238.864,-257.158c3.617,-244.234 -253.064,-259.481 -259.984,-271.684c-51.408,-90.65 -86.357,-212.846 -311.786,-214.139c-279.231,-1.603 -318.993,326.637 -330.207,329.253c-84.401,19.693 -217.261,51.415 -215.849,224.97c1.416,173.952 204.998,188.518 204.998,188.518Z",
    style: {
      fill: "#e5e5e5"
    }
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M268.393,436.194c-90.733,21.54 -222.581,60.885 -221.113,241.213c0.781,95.963 57.084,148.12 113.434,176.128c54.571,27.125 108.975,30.939 108.975,30.939c0.443,0.032 0.887,0.048 1.332,0.048l673.963,0.24c0.665,0 1.33,-0.035 1.991,-0.105c-0,0 251.946,-26.968 255.628,-275.526c3.086,-208.333 -170.254,-261.456 -243.973,-280.614c-8.36,-2.172 -16.923,-4.551 -21.373,-5.808c-30.844,-55.518 -57.887,-120.682 -122.158,-165.257c-44.83,-31.091 -107.707,-52.625 -202.907,-53.171c-234.971,-1.349 -310.329,217.614 -336.474,307.358c-2.76,9.474 -5.566,18.785 -7.325,24.555Zm3.36,410.825c-5.676,-0.498 -49.931,-4.986 -94.348,-27.064c-45.795,-22.763 -91.992,-64.865 -92.626,-142.854c-1.307,-160.58 123.268,-188.337 201.36,-206.557c3.456,-0.807 9.735,-3.185 13.999,-11.697c2.427,-4.844 6.134,-18.014 11.583,-36.719c23.568,-80.895 88.452,-281.563 300.256,-280.348c85.144,0.489 141.656,18.679 181.751,46.487c61.095,42.372 84.246,105.981 113.833,158.152c1.502,2.65 4.378,6.294 10.042,9.075c4.714,2.314 15.978,5.26 31.595,9.318c64.558,16.777 218.611,61.32 215.909,243.764c-3.074,207.534 -205.894,236.773 -221.189,238.684c-0.018,0.002 -672.128,-0.238 -672.128,-0.238l-0.037,-0.003Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M756.818,958.06l-97.465,168.814",
    style: {
      fill: "none",
      stroke: "#000",
      strokeWidth: "33.33px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M564.804,958.06l-97.465,168.814",
    style: {
      fill: "none",
      stroke: "#000",
      strokeWidth: "33.33px"
    }
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(Svg1183);
export default __webpack_public_path__ + "static/media/1183.c3aa89b8cd9e4b9a6c086be0c2249743.svg";
export { ForwardRef as ReactComponent };